import { NgModule } from '@angular/core';
import { SharedModule } from 'src/app/shared/shared.module';
import { NotesComponent } from './notes.component';
import { NotesListSectionComponent } from './notes-list-section/notes-list-section.component';

@NgModule({
  imports:
    [
      SharedModule
    ],
  declarations:
    [
      NotesComponent,
      NotesListSectionComponent
    ],
  exports:
    [
      NotesComponent,
      NotesListSectionComponent
    ]
})
export class NotesModule { }
